import React, { Component } from "react";

class Title extends Component {
 	render() {
	    return (
			<div className="fram_cust full_width" style={{marginTop: this.props.headerHeight+'px'}}>
				<div className="container">
					<h1>Custom Mat Board</h1>
				</div>
			</div>
	    );
  	}
}

export default Title;